import { type FC, useMemo } from 'react';

import { Select, type SelectProps } from '@/components/common/select/Select';
import { useFormatOperationPeriod } from '@/hooks/use-format-operation-period';

import { DashboardV2PeriodType } from '../../../../../generated/graphql';

type OperationPeriodSelectProps = Omit<SelectProps<DashboardV2PeriodType>, 'options'> & {
  withHalfYear?: boolean;
};

export const OperationPeriodSelect: FC<OperationPeriodSelectProps> = (props) => {
  const formatOperationPeriod = useFormatOperationPeriod();

  const { withHalfYear = true, ...selectProps } = props;

  const options = useMemo(
    () =>
      [
        DashboardV2PeriodType.Last_7Days,
        DashboardV2PeriodType.Last_14Days,
        DashboardV2PeriodType.LastMonth,
        ...(withHalfYear ? [DashboardV2PeriodType.HalfYear] : []),
      ].map((type) => ({ node: formatOperationPeriod(type), value: type })),
    [formatOperationPeriod, withHalfYear]
  );

  return <Select options={options} {...selectProps} />;
};
